<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Empresas
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Empresas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="agregarEmpresa.show()" size="sm" mdbWavesEffect>
        Agregar
      </button>
    </div>



  </div>

</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Mes</th>
            <th scope="col">Año</th>
            <th scope="col">Sucursal</th>
            <th scope="col">Empresa de venta $</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>01</td>
            <td>2018</td>
            <td>Casa Matriz</td>
            <td>00.000.000</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar Empresa-->
<div mdbModal style="overflow-y: auto" #agregarEmpresa="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarEmpresa.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos del Empresa
                </h5>
              </div>
            </div>

            <div class="row filtros-body" style="border-bottom: 1px solid #dee2e6">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="rutEmpresa" class="form-control" placeholder="99.999.999-9" required
                    #rutEmpresa />
                  <label for="rutEmpresa">RUT</label>
                </div>
                <div class="md-form">
                  <input value="" type="text" id="nombreEmpresa" class="form-control" placeholder="99.999.999-9"
                    required #nombreEmpresa />
                  <label for="nombreEmpresa">Nombre</label>
                </div>
                <div class="switch info-switch">
                  <h5>¿ Es Holding ?</h5>
                  <label>No<input class="form-check-input" type="checkbox" id="holding" formControlName="holding" />
                    <span class="lever"></span>Si</label>
                </div>
                <div class="switch info-switch">
                  <h5>Estado</h5>
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estado" formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarEmpresa.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="submit">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<div mdbModal #seleccionarCliente="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar cliente
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="seleccionarCliente.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="nombreProduct" class="form-control" placeholder="Nombre o RUT del cliente"
                required #nombreProduct />
              <label for="nombreProduct">Nombre o RUT del cliente</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarCliente.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center" class="text-center">RUT</th>
              <th scope="col" class="text-center" class="text-center">
                Nombre
              </th>
              <th scope="col" class="text-center" class="text-center">
                Sucursal
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarCliente.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarCliente.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre cliente</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarCliente.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<div mdbModal #seleccionarVendedor="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar vendedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="seleccionarVendedor.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="md-form">
              <input value="" type="text" id="rutVend" class="form-control" placeholder="Nombre o RUT del vendedor"
                required #rutVend />
              <label for="rutVend">Nombre o RUT del vendedor</label>
            </div>
          </div>
          <div class="col" style="width: 50px">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="seleccionarVendedor.show()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
        </div>
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" class="text-center">RUT</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Sucursal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>99.999.999-9</td>
              <td>Nombre vendedor</td>
              <td>Matriz</td>
              <td>
                <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                  (click)="seleccionarVendedor.hide()">
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>